import styled, {css} from 'styled-components';

import {TextField} from '~atoms/TextField';
import {textCss} from '~atoms/Text';

export const Container = styled.div`
    display: flex;
    align-items: center;
    padding-top: 2px;
`;

export const TextButton = styled.button`
    margin: 0 0 0 17px;
    padding: 0;
    border: 0;
    appearance: none;
    background: none;
    cursor: pointer;
    transition: ease-in-out 300ms;
    min-width: 5ch;

    &:hover {
        color: var(--dark-gray);
    }
`;

type FieldProps = {
    currency: boolean;
    empty: boolean;
};

export const Field = styled(TextField)<FieldProps>`
    width: 91px !important;

    ${({currency, empty}) =>
        currency &&
        css`
            padding-left: 13px !important;

            &::after {
                ${textCss}
                content: '$';
                position: absolute;
                top: 8px;
                left: 12px;
                color: black;

                // 'input:empty +' selector can't target sibling pseudoelement
                ${() =>
                    empty &&
                    css`
                        // Same as placeholder
                        color: var(--gray-text);
                    `}
            }
        `}

    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const Separator = styled.div`
    background: hsl(0, 0%, 90%);
    height: 1px;
    width: 16px;
    margin: 0 4px;
`;
